import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function PrivateRoute({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(
        !!(localStorage.getItem('user-token') && localStorage.getItem('user-token') !== '')
    );
    const location = useLocation();

    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'user-token') {
                setIsAuthenticated(!!(e.newValue && e.newValue !== ''));
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    return isAuthenticated ? children : <Navigate to="/login" state={{ from: location, isLoggedIn: false }} replace />;
}
